export const meta: BlockMeta = {
  title: "Generic Page Header",
  tags: ["#page"],
  postMetaBlock: {
    fieldName: "genericPageHeader",
    postTypes: ["page"],
  },
}

import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { cn } from "tailwind-variants"

export default defineBlock("content/generic-page-header", (props) => {
  return (
    <Appear className="relative">
      <div className={cn("header-space content-sized flex flex-col items-start justify-end")}>
        <div className={cn("header-space flex flex-col w-full relative")}>
          <h2 className="type-mobile-headings-heading-xl md:type-desktop-headings-heading-xl">
            {env.admin ? (
              <EditableText as="span" store={usePostTitleEditor()} className="" placeholder="Enter a title" />
            ) : (
              props.page?.title || props.job?.title
            )}
          </h2>
          <EditableText
            as="p"
            store="subtitle"
            className="type-mobile-headings-heading-l md:type-desktop-headings-heading-l text-concrete md:max-w-[80%] text-balance"
            placeholder="Enter an optional subtitle"
          />
        </div>
      </div>
    </Appear>
  )
})
